import React, {
  ReactChild,
  useContext,
  useEffect,
  useRef,
  useState
} from 'react'
import { CONFIG } from './config'
import './styles.scss'
import mapboxgl from 'mapbox-gl'
import { initOptionsT } from './types'

export const MapContext = React.createContext<mapboxgl.Map | null>(null)

export const MapboxMap = ({
  initOptions,
  children,
  token,
  getMap
}: {
  initOptions: initOptionsT
  children?: ReactChild
  token: string
  getMap?: (a: mapboxgl.Map) => void
}) => {
  const mapContainer = useRef<string | HTMLElement>()
  const [map, setMap] = useState<mapboxgl.Map | undefined>()
  const MapContainer = useRef<HTMLDivElement>()
  useEffect(() => {
    if (!mapContainer.current) return
    mapboxgl.accessToken = token
    const map = new mapboxgl.Map({
      ...initOptions,
      ...{
        container: mapContainer.current
      }
    })
    map.on('load', () => {
      console.warn('Map load')
      map.maincontainer = MapContainer
      map.popups = {}
    })
    setMap(map)

    if (getMap) getMap(map)
  }, [mapContainer])

  return (
    <>
      <div className='MapboxMap' ref={MapContainer}>
        <div ref={mapContainer} id='map' />
        {map && (
          <MapContext.Provider value={map}>
            {children && <div className='MapboxMapOverlay'>{children}</div>}
          </MapContext.Provider>
        )}
      </div>
    </>
  )
}
